import React, { useRef } from 'react';

import { Tooltip } from 'src/app/components/lib/tooltip';
import { useListWithMaxHeight } from 'src/app/hooks/use-list-with-max-height';

import { SummaryFieldValue, TooltipContents, TooltipIndicatorText } from './styled';

export function AvailableToWithOverflow({ noun, options }: { noun: string; options: string[] }) {
  const ref = useRef<HTMLDivElement>(null);

  const { displayedOptions, hiddenOptions } = useListWithMaxHeight({
    font: 'var(--font-small-13pt-normal)',
    maxListHeight: 36,
    ref,
    options,
  });

  const numberOfHiddenOptions = hiddenOptions.length ?? 0;

  const allSelected = options.length === 0;

  return (
    <SummaryFieldValue ref={ref}>
      {allSelected && `All ${noun}`}
      {!allSelected && (
        <>
          {displayedOptions.join(', ')}
          {numberOfHiddenOptions > 0 && (
            <>
              {' + '}
              <Tooltip
                title={
                  <TooltipContents>
                    {hiddenOptions.map((option) => (
                      <div key={option}>{option}</div>
                    ))}
                  </TooltipContents>
                }
              >
                <TooltipIndicatorText>{numberOfHiddenOptions} more</TooltipIndicatorText>
              </Tooltip>
            </>
          )}
        </>
      )}
    </SummaryFieldValue>
  );
}
